<template>
    <div >
        <v-card elevation="0" style="width: 100% !important">
            <v-card-title>
                <v-btn
                    depressed
                    @click="openCreate()"
                    color="green darken-2"
                    outlined
                    dark
                    small
                    class="d-flex justify-end"
                >
                    Crear Grupos
                    <v-icon right>mdi-select-group</v-icon>
                </v-btn>
            </v-card-title>
            <v-card elevation="0" class="pa-4">
                <v-data-table
                    :headers="headers"
                    :items="groups"
                    class="elevation-0"
                    :search="search"
                    :footer-props="footer_props"
                >
                    <template v-slot:top>
                        <v-text-field
                            v-model="search"
                            label="Buscar"
                            class="mx-4"
                        ></v-text-field>
                    </template>
                    <template v-slot:item.Actions="{ item }">
                        <v-col md="12">
                            <div class="d-flex flex-row justify-space-between">
                                <v-btn
                                    v-if="hasSuperAdminPermission"
                                    fab
                                    @click="openEdit(item)"
                                    x-small
                                    color="orange"
                                    text
                                >
                                    <v-icon> mdi-pen </v-icon>
                                </v-btn>
                                <v-btn
                                    v-if="hasSuperAdminPermission"
                                    class="ml-1"
                                    fab
                                    @click="openDeleteDialog(item)"
                                    x-small
                                    color="red"
                                    text
                                >
                                    <v-icon> mdi-delete </v-icon>
                                </v-btn>
                            </div>
                        </v-col>
                    </template>
                </v-data-table>
            </v-card>
            <v-card-actions elevation="0" class="justify-end mt-n8">
                <v-btn
                    text
                    color="red"
                    @click="isOpenGroupsSummary = false"
                >
                    Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
        <GroupsForm />
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { clone, objectSnakeToCamelCase } from '@/util/libUtil.js';
import GroupsForm from '@/components/DatabaseManagement/Auth/Groups/GroupsForm.vue';

export default {
    data: () => ({
        search: '',
        headers: [
            {
                text: 'ID',
                value: 'id',
                align: 'start',
            },
            {
                text: 'Name',
                value: 'name',
                align: 'start',
            },
            {
                text: 'Acciones',
                value: 'Actions',
                align: 'center',
                sortable: false,
                width: '10px',
            },
        ],
        footer_props: {
            disableItemsPerPage: true,
            itemsPerPageOptions: [10],
        },
    }),
    components: {
        GroupsForm,
    },
    computed: {
        isOpenGroupsSummary: {
            get() {
                return this.$store.state.databaseManagement.auth.groups.isOpen;
            },
            set(value) {
                this.$store.commit('databaseManagement/auth/isOpenGroupsSummary', value);
            },
        },
        ...mapState('databaseManagement/auth', {
            groups: (state) => state.groups.groups,
        }),
        ...mapGetters('login', {
            hasSuperAdminPermission: 'hasSuperAdminPermission',
        }),
    },
    methods: {
        openEdit(item) {
            item.cookie = JSON.stringify(item.cookie);
            this.$store.commit('databaseManagement/auth/groupsForm', item);
            this.$store.commit('databaseManagement/auth/groupsType', 'EDIT');
            this.$store.commit('databaseManagement/auth/isOpenGroupsView', true);
        },
        openCreate() {
            this.$store.commit('databaseManagement/auth/groupsType', 'CREATE');
            this.$store.commit('databaseManagement/auth/isOpenGroupsView', true);
        },
        openDeleteDialog(item) {
            let deleteObj = {
                toDeleteId: item.id,
                toDeleteType: 'GROUPS',
                isOpenDeleteDialog: true,
            };

            this.$store.commit('util/deleteDialog', clone(deleteObj));
        },
        ...mapActions('databaseManagement/auth', ['getGroups']),
    },
    watch: {},
};
</script>

<style>
</style>







